import { Box, Container, Grid, Typography } from "@material-ui/core";

import React, { Fragment, useContext, useEffect } from "react";
import SectionHeader from "../../components/SectionHeader";
import { AuthContext } from "../../auth/AuthContext";
import { useNavigate } from "react-router-dom";

export default function EmailChangeRequestComplete({ email }) {
  const { currentUser } = useContext(AuthContext);
  const navigate = useNavigate();
  useEffect(() => {
    if (currentUser === undefined) {
      return;
    }
    if (!currentUser) {
      navigate("/login", {
        state: {
          from: window.location.pathname,
          search: window.location.search,
        },
      });
    }
    document.title = "メールアドレス変更リクエスト完了 | じぶん専用IT相談室";
  }, [currentUser]);

  const registerationList = [
    {
      name: "メールアドレス入力",
      color: "grey",
    },
    {
      name: "メールアドレス変更URLを送信しました",
      color: "grey",
    },
    {
      name: "メールのご確認",
      color: "primary",
    },
    {
      name: "メールアドレス変更完了",
      color: "primary",
    },
  ];
  return (
    <Box component={"section"} className="section bg-dots">
      <Container className="container">
        <Box sx={{ textAlign: "center" }} justifyContent={"center"}>
          <Grid container justifyContent="center">
            <Grid item md={6}>
              <SectionHeader
                currentPage={"メールアドレス変更の<br/>URLを送信しました"}
                preHeading={""}
              />
              <Typography
                component={"p"}
                className="mobile-text-left"
                // style={{ maxWidth: "600px", margin: "0 auto" }}
              >
                入力いただいたアドレス宛にメールを送信しました。
                <br />
                <strong>
                  メール文中に「メールアドレス変更URL」をクリックしてください。
                </strong>
              </Typography>
              <Typography
                style={{ marginTop: "30px" }}
                className="mobile-text-left"
              >
                確認メールは「{email}」からお送りします。
                メールが届かない場合は、迷惑メールフォルダに分類されていないか
                ご確認の上再度お試しください。
              </Typography>
            </Grid>
          </Grid>

          <Box className="registeration-list-wrapper element-box">
            {registerationList.map((list, idx) => (
              <Grid container spacing={2} alignItems="center" key={idx}>
                <Grid item>
                  <span className={`number-circle ${list.color}`}>
                    {idx + 1}
                  </span>
                </Grid>
                <Grid item xs>
                  <Typography
                    className={`color-${list.color} password-complete-text `}
                    component={"p"}
                  >
                    {list.name}
                  </Typography>
                </Grid>
              </Grid>
            ))}
          </Box>
        </Box>
      </Container>
    </Box>
  );
}
